const DEFAULT_OPTIONS = {
  enableHighAccuracy: false,
  cachingPeriod: 2 * 60 * 1000,
  timeoutPeriod: 15 * 1000
};

class BrowserGeolocationManager {
  constructor(options = {}) {
    this.options = {...DEFAULT_OPTIONS, ...options};
  }

  /**
   * Get the current location of a user
   *
   * @param {Function} [onSuccess] - success callback
   * @param {Function} [onError] - error callback
   */
  getCurrentPosition(onSuccess, onError) {
    navigator.geolocation.getCurrentPosition(
      (position) => onSuccess(position),
      (error) => onError(error),
      {
        enableHighAccuracy: this.options.enableHighAccuracy,
        timeout: this.options.timeoutPeriod,
        maximumAge: this.options.cachingPeriod
      }
    );
  }
}

export default BrowserGeolocationManager;



// WEBPACK FOOTER //
// ./app/assets/javascripts/lib/browserGeolocationManager.js